export {default} from './AuthGuard';
export * from './types';



// WEBPACK FOOTER //
// ./src/components/AuthGuard/index.ts